import { money, tag } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const FetchPayOverTimeHistoryDetails = gql`
  fragment TransactionRowComponentFragment on TransactionRowComponent {
    id
    primaryDetail {
      copy
    }
    primaryText {
      copy
    }
    secondaryDetail {
      copy
    }
    secondaryText {
      copy
    }
    tags {
      ...tag
    }
  }

  query PayOverTimeLoanHistoryDetails($loanId: ID!) {
    payOverTimeLoanHistoryDetails(loanId: $loanId) {
      ... on PayOverTimeLoanHistoryDetailsError {
        __typename
        code
        message
        title
      }
      ... on PayOverTimeLoanHistoryDetailsSuccess {
        __typename
        loanName
        fee {
          ...money
        }
        id
        originationDate
        principal {
          ...money
        }
        totalAmount {
          ...money
        }
        transactions {
          children {
            ...TransactionRowComponentFragment
          }
          id
          title {
            copy
          }
        }
      }
    }
  }

  ${money}
  ${tag}
`;

export default FetchPayOverTimeHistoryDetails;
